// import { AccessoryProductSlider } from 'components/desktop/Recipe/AccessoryProductSlider/AccessoryProductSlider';
import { IngredientsProductSlider } from 'components/desktop/Recipe/IngredientsProductSlider/IngredientsProductSlider';
import { SimilarRecipes } from 'components/desktop/Recipe/SimilarRecipes/SimilarRecipes';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import ENTITLEMENTS from 'enums/entitlements';
import * as Product from 'types/Product/RecipeProduct';
import { Recipe } from 'types/Recipe/Recipe';
import { Segment } from 'types/Recipe/Segment';

interface IProps {
	selectedCultureCode: string;
	ingredientProducts: Product.Type[];
	segments: Segment[];
	recipe: Recipe;
}

const RecipeSuggestionsComponent = (props: IProps) => {
	return (
		<>
			<div className="margin-top-25">
				<RenderIf entitlements={[ENTITLEMENTS.SIMILAR_RECIPES]}>
					<SimilarRecipes
						recipeId={props.recipe.id}
						stepsTranslations={props.recipe.stepsTranslations}
						shortDescriptionTranslations={props.recipe.shortDescriptionTranslations}
					/>
					<br />
				</RenderIf>
				<IngredientsProductSlider segments={props.segments} />
				{/*<br />
				<AccessoryProductSlider {...props} /> */}
			</div>
		</>
	);
};

export default RecipeSuggestionsComponent;
